var rgb = function (value) {
    var hex = value.trim().replace(/^#/, '');
    if (/^[a-f\d]{3}$/i.test(hex))
        return hex.split('').map(function (char) { return parseInt(char + char, 16); });
    if (/^[a-f\d]{6}(?:[a-f\d]{2})?$/i.test(hex))
        return [0, 2, 4].map(function (index) { return parseInt(hex.slice(index, index + 2), 16); });
    var match = value.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    return match ? match.slice(1, 4).map(Number) : null;
};
var mix = function (base, target, weight) {
    var left = rgb(base), right = rgb(target);
    if (!left || !right)
        return 'color-mix(in srgb, ' + base + ' ' + Math.round((1 - weight) * 100) + '%, ' + target + ')';
    return ('#' +
        left
            .map(function (channel, index) {
            return Math.round(channel * (1 - weight) + right[index] * weight)
                .toString(16)
                .padStart(2, '0');
        })
            .join(''));
};
export var createOnboardingPalette = function (theme) {
    var primary = theme.primaryColor || '#087565';
    var background = theme.backgroundColor || '#ffffff';
    return {
        primary: primary,
        hover: mix(primary, '#000000', 0.15),
        soft: mix(primary, background, 0.92),
        surface: mix(primary, background, 0.97),
        border: mix(primary, background, 0.8),
        muted: mix(primary, background, 0.55),
        background: background,
        text: theme.primaryTextColor || '#102a27',
        secondary: theme.secondaryTextColor || '#60736d',
        onPrimary: theme.buttonContentColor || '#ffffff',
        input: theme.inputBackgroundColor || mix(primary, background, 0.97),
        inputText: theme.inputTextColor || theme.primaryTextColor || '#102a27',
        inputLabel: theme.inputLabelColor || theme.primaryTextColor || '#102a27',
        placeholder: theme.inputPlaceholderColor || theme.secondaryTextColor || '#60736d',
    };
};
export var onboardingColorVariables = function (theme) {
    return Object.entries(createOnboardingPalette(theme))
        .map(function (_a) {
        var name = _a[0], value = _a[1];
        return '--onboarding-' + name + ': ' + value + ';';
    })
        .join('\n');
};
